import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import './imprimirMinutaGrilla.scss';

import { adaptImprimirMinutasConexionesArray, GET_IMPRIMIR_MINUTA_CONEXIONES } from '../../../data/graphQL/queries/ImprimirMinuta/getImprimirMinutaConexiones';

export const ImprimirMinutaDetalleItems = ({
  dataRegistro,
  itemsMinuta,
  setItemsMinuta
}) => {
  const [getItems, { data: dataItems, loading: itemsMinutaLoading }] = useLazyQuery(GET_IMPRIMIR_MINUTA_CONEXIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataItems) return;
    setItemsMinuta(adaptImprimirMinutasConexionesArray(dataItems.conexionesMinuta));
  }, [dataItems]);


  useEffect(() => {
    if (!itemsMinutaLoading)
      getItems({ variables: { idMinuta: dataRegistro?.idMinuta } });
  }, []);

  const initialColumns = [
    {
      headerName: 'Conexión',
      flex: 0.10,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return <div style={{ paddingLeft: '18px' }}>
          {row.idConexion}
        </div>;
      }
    },
    {
      field: 'fechaConexion',
      headerName: 'Fecha Conexión',
      headerAlign: 'left',
      align: 'left',
      type: 'date'
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [itemsMinuta]);

  return (
    <>
      <Grid container spacing={1} sx={{ marginTop: '10px' }}>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='section-title'>Items de la Minuta</div>
          <DataGridGenerico
            columns={columns}
            rows={itemsMinuta}
            toolbar={false}
            maxWidth={columns.reduce(
              (total, column) => total + (column.width || 0),
              0
            )}
            loading={itemsMinutaLoading} />

        </Grid>
      </Grid>
    </>);

};